import React from "react";
import * as unavailablepageStyle from "./UnavailablePage.module.css";
function UnavailablePage() {
  return (
    <div className={unavailablepageStyle.unavailablepage}>
      <h1>Comming Soon</h1>
    </div>
  );
}

export default UnavailablePage;
